<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1200px"
        :title="$t('platformList.add.dialogTitle')"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container" v-loading="loading">
            <el-form ref="addForm" :model="addForm" label-width="100px" @keydown.enter.native.prevent>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item
                            :label="$t('platformList.add.name')"
                            :rules="[
                                {
                                    required: true,
                                    message: `${$t(
                                        'platformList.add.inputPlaceholder'
                                    )}${$t('platformList.add.name')}`,
                                },
                            ]"
                            prop="name"
                            size="small"
                        >
                            <el-input
                                clearable
                                :placeholder="`${$t(
                                    'platformList.add.inputPlaceholder'
                                )}${$t('platformList.add.name')}`"
                                size="small"
                                v-model="addForm.name"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item
                            :label="$t('platformList.add.code')"
                            size="small"
                        >
                            <el-input
                                clearable
                                :placeholder="`${$t(
                                    'platformList.add.inputPlaceholder'
                                )}${$t('platformList.add.code')}`"
                                size="small"
                                v-model="addForm.code"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            :label="$t('platformList.add.url')"
                            size="small"
                        >
                            <el-input
                                clearable
                                :placeholder="`${$t(
                                    'platformList.add.inputPlaceholder'
                                )}${$t('platformList.add.url')}`"
                                size="small"
                                v-model="addForm.url"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            :label="$t('platformList.add.sort')"
                            size="small"
                        >
                            <el-input
                                clearable
                                :placeholder="`${$t(
                                    'platformList.add.inputPlaceholder'
                                )}${$t('platformList.add.sort')}`"
                                size="small"
                                v-model="addForm.sort"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            :label="$t('platformList.add.desc')"
                            size="small"
                        >
                            <el-input
                                clearable
                                :placeholder="`${$t(
                                    'platformList.add.inputPlaceholder'
                                )}${$t('platformList.add.desc')}`"
                                size="small"
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 8 }"
                                resize="none"
                                v-model.number="addForm.desc"
                                maxlength="500"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label-width="0">
                            <imgUpload
                                :images="addForm.images"
                                @imagesChange="imagesChange"
                                ref="uploadsRef"
                                :width="'150'"
                                :height="'150'"
                                :oss="false"
                                :multiple="true"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >{{ $t("platformList.add.save") }}</el-button
            >
            <el-button size="small" @click="addVisible = false">{{
                $t("platformList.add.close")
            }}</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import imgUpload from "@/common/components/imgUpload";
export default {
    components:{
      imgUpload
    },
    data() {
        return {
            addForm: {
                name: "",
                sort: "",
                code: "",
                url: "",
                desc: "",
            },
            loading: false,
        };
    },
    methods: {
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.addForm = {
                name: "",
                sort: "",
                code: "",
                url: "",
                desc: "",
            };
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },
        /**
         *  保存
         */
        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .platform({ ...this.addForm }, "post")
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "新增成功"
                                        : "Success"
                                );
                                this.$parent.platform();
                                this.closeDialog();
                                this.loading = false;
                            }
                        });
                }
            });
        },
    },
    props: {
        addVisible: Boolean,
    },
};
</script>
<style lang="scss">
.add {
    .el-form-item__content {
        .el-select,
        .el-select--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
    }
}
</style>
